import { Termin_Wiederholung } from '@/gql/graphql';
import { t } from 'i18next';
export enum TerminWiederholung {
  OHNE = 'OHNE',
  TAEGLICH = 'TAEGLICH',
  WOECHENTLICH = 'WOECHENTLICH',
  MONATLICH = 'MONATLICH',
  JAEHRLICH = 'JAEHRLICH',
}

export function getWiederholungStringFromTerminWiederholung(
  wiederholung: TerminWiederholung,
) {
  switch (wiederholung) {
    case TerminWiederholung.OHNE:
      return t('entities.wiederholung.einmalig');
    case TerminWiederholung.TAEGLICH:
      return t('entities.wiederholung.taeglich');
    case TerminWiederholung.WOECHENTLICH:
      return t('entities.wiederholung.woechentlich');
    case TerminWiederholung.MONATLICH:
      return t('entities.wiederholung.monatlich');
    case TerminWiederholung.JAEHRLICH:
      return t('entities.wiederholung.jaehrlich');
    default:
      return '';
  }
}

export const terminWiederholungValues = [
  'OHNE',
  'TAEGLICH',
  'WOECHENTLICH',
  'MONATLICH',
  'JAEHRLICH',
] as const;

export const wiederholungToGraphQLMap: Record<
  TerminWiederholung,
  Termin_Wiederholung
> = {
  [TerminWiederholung.JAEHRLICH]: Termin_Wiederholung.Jaehrlich,
  [TerminWiederholung.MONATLICH]: Termin_Wiederholung.Monatlich,
  [TerminWiederholung.WOECHENTLICH]: Termin_Wiederholung.Woechentlich,
  [TerminWiederholung.TAEGLICH]: Termin_Wiederholung.Taeglich,
  [TerminWiederholung.OHNE]: Termin_Wiederholung.Ohne,
} as const satisfies Record<TerminWiederholung, Termin_Wiederholung>;
